import Redact from "redact-object";

const DEFAULT_SANITIZE_KEYS = [
  "password",
  "secret",
  "token",
  "credit_card",
  "gateway",
  "exp_",
  "last4",
  "billing_details",
];

export const scrubMonitoringPayload = <T extends Record<string, unknown>>(
  payload: T,
  sanitizeKeys = DEFAULT_SANITIZE_KEYS,
): T =>
  Redact(payload, sanitizeKeys, undefined, {
    partial: true,
    ignoreUnknown: true,
  }) as T;
